import React from 'react';
import styled from "styled-components";
import {hover, whites} from "@/styles/globalStyleVars";

const MyComponent = ({background, hoverBackground, color, hovercolor}) => {
    return (
        <StyledComponent className={'go-right'} background={background} hoverBackground={hoverBackground} color={color}
                         hovercolor={hovercolor}>
            <svg xmlns="http://www.w3.org/2000/svg" width="8.414" height="14.828" viewBox="0 0 8.414 14.828">
                <path id="Path_10575" data-name="Path 10575" d="M2909.682,2163.84l6,6-6,6"
                      transform="translate(-2908.268 -2162.426)" fill="none" stroke="#fff" stroke-linecap="round"
                      stroke-linejoin="round" stroke-width="2"/>
            </svg>


        </StyledComponent>
    );
};

const StyledComponent = styled.section`
    height: 50px;
    width: 50px;
    border-radius: 50%;
    background-color: ${p => p.background || '#638297'};
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden;
    cursor: pointer;

    svg {
        z-index: 2;
        position: relative;

        line {
            stroke: ${p => p.color || 'rgb(60, 60, 59)'};
            transition: .3s ease;
        }
    }

    &:before {
        content: '';
        position: absolute;
        height: 0;
        width: 100%;
        left: 0;
        bottom: 0;
        border-radius: 50%;
        background-color: ${p => p.hovercolor || '#978C21'};
        transition: .4s ease;
    }

    &:hover {
        &:before {
            height: 100%;
        }

        line {
            stroke: ${p => p.hovercolor || whites}
        }
    }
    
    &.swiper-button-disabled{
        &:before{
            display: none;
        }
    }
`;

export default MyComponent;